<template lang="html">
  <div class="p-3">
    <div v-if="load">
      <h6>Cobrança</h6>
      <div class="aside-options">
        <div class="clearfix mt-4">
          <small><b>Status da Cobrança</b></small>
          <b-badge :variant="variant" class="float-right">{{ cobranca.status }}</b-badge>
        </div>
        <div class="message" v-if="cobranca.comment">
          <div>
            <small class="text-muted">{{ cobranca.author }}</small>
            <small class="text-muted float-right mt-1" :title="cobranca.dateCreated | moment-complete">{{ cobranca.dateCreated | moment-short-date }}</small>
          </div>
          <!--<div class="text-truncate font-weight-bold">Lorem ipsum dolor sit amet</div>-->
          <small class="text-muted">{{ cobranca.comment }}</small>
        </div>
        <div class="text-center mt-2">
          <b-button variant="danger" class="mr-1" v-if="cobranca.status === 'Ativa'" v-b-modal.modal-prevent-closing>Suspender cobrança</b-button>
          <b-button variant="success" class="mr-1" v-else-if="cobranca.status === 'Suspensa'" v-b-modal.modal-prevent-closing>Reativar cobrança</b-button>
        </div>
        <b-modal
          id="modal-prevent-closing"
          ref="modal"
          title="Suspender cobrança"
          @show="resetModal"
          @hidden="resetModal"
          @ok="handleOk"
        >
          <form ref="form" @submit.stop.prevent="handleSubmit">
            <b-form-group
              label="Explique o motivo da suspensão da cobrança"
              label-for="comment-input"
              invalid-feedback="O motivo é obrigatório"
            >
              <b-form-textarea
                id="comment-input"
                v-model="comment"
                :state="commentState"
                rows="3"
                max-rows="8"
                required
              ></b-form-textarea>
            </b-form-group>
          </form>
        </b-modal>
        <hr>
        <h6>Boletos</h6>
        <div>
          <b-form-select v-model="selectedInstallment" :options="installments"></b-form-select>
          <div v-if="selectedInstallment">
            <div class="message">
              <div>
                <small class="text-muted">Valor</small>
                <small class="text-muted float-right mt-1">{{ selectedInstallment.amount | numeral('$ 0,0.00')}}</small>
              </div>
              <div v-if="selectedInstallment.dateSettled !== null">
                <small class="text-muted">Data pagamento</small>
                <small class="text-muted float-right mt-1">{{ selectedInstallment.dateSettled | moment-date }}</small>
              </div>
            </div>
            <div>
              <b-form-select v-model="ratingSelected" :options="ratingOptions" @change="updateRating(tx)" size="sm" class="mt-3"></b-form-select>
            </div>
            <div class="text-center mt-2">
              <b-button variant="primary" class="mr-1" v-b-modal.modal-due-date>Alterar vencimento</b-button>
            </div>
            <div class="message mt-2" v-if="selectedInstallment.comment">
              <div>
                <small class="text-muted">{{ selectedInstallment.userComment }}</small>
                <small class="text-muted float-right mt-1" :title="selectedInstallment.dateCommented | moment-complete">{{ selectedInstallment.dateCommented | moment-short-date }}</small>
              </div>
              <!-- <div class="text-truncate font-weight-bold">Lorem ipsum dolor sit amet</div>-->
              <small class="text-muted">{{ selectedInstallment.comment }}</small>
              <div class="mt-2">
                <b-list-group-item class="d-flex justify-content-between align-items-center">
                  Alterou o boleto
                  <c-switch class="mx-1" color="success" v-model="originalChanged" label outline variant="pill" v-bind="labelIcon"/>
                </b-list-group-item>
              </div>
            </div>
          </div>
        </div>
        <b-modal
          v-if="selectedInstallment"
          id="modal-due-date"
          ref="modalDueDate"
          :title="'Alteração de vencimento do boleto ' + selectedInstallment.number"
          @show="resetModalDueDate"
          @hidden="resetModalDueDate"
          @ok="handleOkDueDate"
        >
          <form ref="formDueDate" @submit.stop.prevent="handleSubmit">
            <b-form-group
              id="input-group-1"
              label="Nova Data de Vencimento:"
              label-for="input-1"
            >
              <input-component id="birthDate" placeholder="__/__/____" mask="##/##/####" type='text' @updateValue="val => newDueDate = val" :model="newDueDate"/>
            </b-form-group>
            <b-form-group
              label="Explique o motivo da alteração de vencimento do boleto"
              label-for="comment-input"
              invalid-feedback="O motivo é obrigatório"
            >
              <b-form-textarea
                id="comment-input"
                v-model="commentDueDate"
                :state="commentDueDateState"
                rows="3"
                max-rows="8"
                required
              ></b-form-textarea>
            </b-form-group>
          </form>
          <div>
          <b-form-checkbox
            id="checkbox-juros"
            v-model="statusJuros"
            name="checkbox-juros"
            value="1"
            unchecked-value="0"
          >
            Adicionar juros
          </b-form-checkbox>

          <div><i class="icon-next-4 ml-2 mr-1"></i>Gerar boleto <strong>{{ statusJuros == '0' ? 'sem juros' : 'com juros' }}</strong></div>
        </div>
        </b-modal>

        <div class="text-center mt-2" v-if="showPayOff">
              <b-button variant="primary" class="mr-1"  v-on:click="showModalPayoff = true"  v-b-modal.modal-payoff>Quitação com Desconto</b-button>
        </div>

        <b-modal
          v-if="showModalPayoff"
          id="modal-payoff"
          ref="modalPayOff"
          :title="'Quitação com Desconto '"
          @show="resetModalPayOff"
          @hidden="resetModalPayOff"
          @ok="handleOkPayOff"
        >
          <form ref="formPayOff" @submit.stop.prevent="handleSubmitPayOff">
            <b-form-group
              :state="commentPayOffState"
              id="input-group-1"
              label="Vencimento do boleto:"
              label-for="input-1"
              invalid-feedback="Data do vencimento do boleto obrigatório"
            >
              <b-form-input id="date" placeholder="__/__/____" v-mask="'##/##/####'" type='text' @updateValue="val => newDueDate = val" v-model="newDueDate"  :state="commentPayOffState" required></b-form-input>
            </b-form-group>
            <b-form-group
              :state="commentPayOffState"
              id="input-group-1"
              label="Valor do boleto de quitação:"
              label-for="input-1"
              invalid-feedback="Valor de quitação do boleto obrigatório"
            >
              <b-form-input id="amount" placeholder="00.00" type='text' @updateValue="val => amount = val" v-model="amount" :state="commentPayOffState" required></b-form-input>
            </b-form-group>
          </form>
          <div><i class="icon-next-4 ml-2 mr-1"></i>Gerar Boleto</div>
        </b-modal>
      </div>
    </div>
    <div v-else>
      É preciso selecionar uma transação com cobrança
    </div>
  </div>
</template>
<script>
import moment from 'moment-timezone'
import { Switch as cSwitch } from '@coreui/vue'
import Input from '../../partial/form/Input.vue'

export default {
  components: {
    cSwitch,
    'input-component': Input
  },
  data () {
    return {
      cobranca: null,
      journeyType: 'DEFAULT',
      showModalPayoff: false,
      showPayOff: false,
      comment: null,
      commentState: true,
      commentDueDate: null,
      commentDueDateState: true,
      commentPayoffState: true,
      load: false,
      installments: null,
      selectedInstallment: null,
      newDueDate: null,
      amount: null,
      originalChanged: null,
      tx: null,
      suggestedAmountPayoff: null,
      labelIcon: {
        dataOn: '\u2713',
        dataOff: '\u2715'
      },
      ratingSelected: null,
      ratingOptions: [
        { value: null, text: 'Selecione uma classificação' },
        { value: 'NO_DELAY', text: 'Sem atraso' },
        { value: 'AWAITING_CANCELLATION', text: 'Aguardando cancelamento' },
        { value: 'DATE_SET', text: 'Data de pagamento definida' },
        { value: 'DO_NOT_KNOW', text: 'Não sabe quando vai conseguir pagar' },
        { value: 'DELAYED_UNANSWERED', text: 'Atrasado sem resposta' }
      ],
      statusJuros: '0',
      ccbType: ''
    }
  },
  computed: {
    variant () {
      var variant = 'primary'
      if (this.cobranca) {
        if (this.cobranca.status === 'Ativa') {
          variant = 'success'
        } else if (this.cobranca.status === 'Suspensa') {
          variant = 'danger'
        }
      }
      return variant
    }
  },
  mounted () {
    console.log(this.$route.params.txid)
    if (this.$route.params.txid) {
      this.getStatus()
    }
  },
  methods: {
    updateRating () {
      this.$http.put(`api/transactions/${this.selectedInstallment.id}/rating`, {
        ratingStatus: this.ratingSelected
      })
        .then(function (res) {
          this.$bvToast.toast('Classificação atualizada com sucesso', {
            autoHideDelay: 5000,
            variant: 'success'
          })
        })
        .catch(function (res) {
          console.log('Error')
          console.log(res)
          this.$bvToast.toast('Ocorreu um erro', {
            autoHideDelay: 5000,
            variant: 'danger'
          })
        })
    },
    getStatus () {
      this.load = false
      if (this.$route.params.txid) {
        this.load = true
        this.$http.get('api/transactions/' + this.$route.params.txid + '/charges')
          .then(function (res) {
            console.log(res)
            this.cobranca = res.data.charge
            this.installments = res.data.installments
            this.journeyType = res.data.journeyType
            this.showPayOff = this.isInstallmentPending() && this.journeyType !== 'GERU'
          })
          .catch(function (res) {
            this.load = false
            this.showPayOff = false
            console.log('Error on charges')
            console.log(res)
          })
      }
    },
    isInstallmentPending () {
      const today = new Date()
      for (let i = 0; i < this.installments.length; i++) {
        const installment = this.installments[i].value
        if (installment.status === 'Pendente' && today > new Date(installment.dueDate)) {
          return true
        }
      }
      return false
    },
    checkFormValidity () {
      this.commentState = this.$refs.form.checkValidity()
      return this.commentState
    },
    checkFormDueDateValidity () {
      this.commentDueDateState = this.$refs.formDueDate.checkValidity()
      return this.commentDueDateState
    },
    checkFormPayOffValidity () {
      this.commentPayoffState = this.$refs.formPayOff.checkValidity()
      return this.commentPayoffState
    },
    resetModal () {
      this.comment = ''
      this.commentState = null
    },
    resetModalDueDate () {
      this.commentDueDate = ''
      this.commentDueDateState = null
    },
    resetModalPayOff () {
      this.newDueDate = ''
      this.amount = 0
    },
    handleOk (bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault()
      // Trigger submit handler
      this.handleSubmit()
    },
    handleOkDueDate (bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault()
      // Trigger submit handler
      this.handleSubmitDueDate()
    },
    handleOkPayOff (bvModalEvt) {
      bvModalEvt.preventDefault()
      console.log(this.checkFormPayOffValidity())
      if (this.checkFormPayOffValidity()) {
        this.handleSubmitPayOff()
      } else {
        this.$bvToast.toast('Valor da quitação e data de vencimento.', { title: 'Preencha os campos obrigatórios', autoHideDelay: 5000, variant: 'danger' })
      }
    },
    handleSubmitPayOff () {
      console.log('Payoff submit')
      this.$http.post(`api/qitech/payoff/` + this.$route.params.txid, {
        expiration: this.newDueDate,
        amount: parseFloat(this.amount.toString().replace(',', '.'))
      }).then(function (res) {
        console.log(res)
        this.$bvToast.toast('Boleto criado com sucesso ', { autoHideDelay: 5000, variant: 'success' })
      })
        .catch(function (res) {
          console.log('Error')
          console.log(res)
          this.suggestedAmountPayoff = res.data.suggestedAmountPayoff
          this.$bvToast.toast(res.data.message, { title: 'Erro ao criar boleto ' + res.data.title, autoHideDelay: 5000, variant: 'danger' })
        })
      this.showModalPayoff = false
    },
    handleSubmit () {
      // Exit when the form isn't valid
      if (!this.checkFormValidity()) {
        return
      }
      var status = (this.cobranca.status === 'Ativa') ? 'SUSPENDED' : 'ACTIVE'
      // Push the name to submitted names
      this.$http.patch('api/transactions/' + this.$route.params.txid + '/charges', {comment: this.comment, status: status})
        .then(function (res) {
          this.getStatus()
        })
        .catch(function (res) {
          console.log('Error')
          console.log(res)
        })
      // Hide the modal manually
      this.$nextTick(() => {
        this.$refs.modal.hide()
      })
    },
    handleSubmitDueDate () {
      // Exit when the form isn't valid
      if (!this.checkFormDueDateValidity()) {
        return
      }
      var novaData = this.newDueDate.substring(4, 8) + '-' + this.newDueDate.substring(2, 4) + '-' + this.newDueDate.substring(0, 2)
      // // Push the name to submitted names
      this.$http.patch('api/boletos/' + this.selectedInstallment.id + '/dueDate', {comment: this.commentDueDate, dueDate: novaData, feesEnable: this.statusJuros})
        .then(function (res) {
          this.getStatus()
          this.$bvToast.toast('Boleto atualizado com sucesso', {
            // title: 'Boleto atualizado com sucesso',
            autoHideDelay: 5000,
            variant: 'success'
          })
        })
        .catch(function (res) {
          console.log('Error')
          console.log(res)
          this.$bvToast.toast(res, {
            title: 'Erro ao atualizar boleto',
            autoHideDelay: 5000,
            variant: 'danger'
          })
        })
      // // Hide the modal manually
      this.$nextTick(() => {
        this.$refs.modalDueDate.hide()
      })
    },
    changeOriginal (val) {
      this.$http.patch('api/boletos/' + this.selectedInstallment.id, {originalChanged: val})
        .then(function (res) {
          this.selectedInstallment.originalChanged = val
          if (res.data.historic) {
            this.$bvToast.toast('Informação atualizada com sucesso', {
              // title: 'Boleto atualizado com sucesso',
              autoHideDelay: 5000,
              variant: 'success'
            })
          }
        })
        .catch(function (res) {
          console.log('Error')
          console.log(res)
          this.$bvToast.toast(res, {
            title: 'Erro ao atualizar boleto',
            autoHideDelay: 5000,
            variant: 'danger'
          })
        })
    }
  },
  watch: {
    '$route.params.txid' () {
      this.getStatus()
    },
    selectedInstallment: function (val) {
      console.log('Atualizando parcela')
      this.originalChanged = val.originalChanged
      moment.locale('pt-br')
      this.newDueDate = moment(val.dueDate).format('DDMMYYYY')
    },
    originalChanged: function (val, valAntigo) {
      console.log(val + '  ' + valAntigo)
      if (valAntigo !== null) {
        this.changeOriginal(val)
      }
    }
  }
}
</script>
<style lang="scss">
.custom-control-label:after, .custom-control-label:before {
    top: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/partial/cobranca/Cobranca.vue